import { instaceStates } from "./consts";
import { Filter } from "./filter";
import { requiredArgument } from "./validators";

export const getGUID = () => {
  const _p8 = (s?: boolean) => {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  };
  return (_p8() + _p8(true) + _p8(true) + _p8()).toUpperCase();
};

export const toQueryString = (object: any) =>
  object ? "?" + new URLSearchParams(object).toString() : "";

export const remove = (source: any[], cb: any) => {
  const exists = source.some(cb);
  if (exists) {
    const index = source.findIndex(cb);
    source.splice(index, 1);
  }
};

export const getValue = (object: any, fieldPath: string) => {
  const regex = new RegExp(/[\.]/gm);
  if (!regex.test(fieldPath)) {
    return object[fieldPath];
  }
  let schema = object;

  const pList = fieldPath.split(".");
  const len = pList.length;
  for (var i = 0; i < len - 1; i++) {
    var elem = pList[i];
    if (!schema[elem]) schema[elem] = {};
    schema = schema[elem];
  }
  return schema[pList[len - 1]];
};

export const getFullName = (
  person: any,
  notDefinedCaption = "Не указано",
): string => {
  if (!person) return "";
  const firstName = person.firstName ?? "";
  const lastName = person.lastName ?? "";
  const patronymic = person.patronymic ?? "";
  return /^\s+$/.test(`${lastName} ${firstName} ${patronymic}`)
    ? `${lastName} ${firstName} ${patronymic}`
    : person.caption ?? notDefinedCaption;
};

export const getImageUrl = (o: any, w: number, h: number): string | null =>
  o?.defaultImageId
    ? `/images/ci${o?.defaultImageId}v${w ?? 150}x${h ?? 150}s0.jpg`
    : null;

export const getInstaceStateName = (instaceStateId: number): string =>
  instaceStates[instaceStateId] ?? "[не определен]";

export const findElementInTree = (
  key: any = requiredArgument("значения для поиска не передано"),
  tree: any = requiredArgument("Дерево для поиска не передано"),
  keyName: string = "id",
): any => {
  let _defined: any = null;

  (function find(key: number, tree: any) {
    for (const branch of tree) {
      if (key === branch[keyName]) {
        _defined = branch;
      }

      if (branch?.children?.length > 0) {
        find(key, branch.children);
      }
    }
  })(key, tree);

  return _defined;
};

export const findParentInTree = (
  key: any = requiredArgument("значения для поиска не передано"),
  tree: any = requiredArgument("Дерево для поиска не передано"),
  keyName: string = "id",
): any => {
  let _defined: any = null;

  (function find(key: number, parent: any) {
    for (const branch of parent.children) {
      if (key === branch[keyName]) {
        _defined = parent;
      }

      if (branch?.children?.length > 0) {
        find(key, branch);
      }
    }
  })(key, {children:tree});

  return _defined;
};

export class TransformInfo{
  public from:string;
  public to:string;

  constructor(from:string, to:string) {
    this.from=from;
    this.to=to;
  }
}


export const deepTransformTree = (src:any, info:TransformInfo[], childrenInfo:TransformInfo) => {
  const treeRes:any[] = [];
  for (const srcElement of src) {
    const itemRes = transformObject(srcElement, info);
    if(srcElement[childrenInfo.from].length){
      itemRes[childrenInfo.to] = deepTransformTree(srcElement[childrenInfo.from], info, childrenInfo);
    }
    treeRes.push(itemRes);
  }
  return treeRes;
}

export const getBase64FromFile = (file: File): Promise<string | null> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const base64 = reader.result?.toString().split(',')[1] || null;
    resolve(base64);
  };
  reader.onerror = (error) => {
    reject(error);
  };
  reader.readAsDataURL(file);
});



export const transformObject = (src:any, info:TransformInfo[] ) => {
  const res:Record<string, any> = {};
  for (const infoItem of info) {
    res[infoItem.to] = src[infoItem.from];
  }
  return res;
}


export const removeElementInTree = (
  key: any = requiredArgument("значения для поиска не передано"),
  tree: any = requiredArgument("Дерево для поиска не передано"),
  keyName: string = "id",
): any => {
  (function find(key: number, tree: any) {
    for (const [index, branch] of tree.entries()) {
      if (key === branch[keyName]) {
        tree.splice(index, 1);
      }
      if (branch?.children?.length > 0) {
        find(key, branch.children);
      }
    }
  })(key, tree);
};

export const updateElementInTree = (
  data: any = requiredArgument("Данные для обновления не передано"),
  tree: any = requiredArgument("Дерево для поиска не передано"),
  update: Function = requiredArgument("CallBack для update а не передано"),
  keyName: string = "id",
): any => {
  for (const branch of tree) {
    if (data[keyName] === branch[keyName]) return update(branch);
    if (!branch?.children) continue;
    updateElementInTree(data, branch.children, update);
  }
};

export const getParentBrachesOfTreeByKeyList = (
  keyList: any = requiredArgument("Элементы для поиска не переданы"),
  tree: any = requiredArgument("Дерево для поиска не передано"),
  keyName: string = "id",
  childrenKeyName: string = "children",
  parentKeyName: string = "parentId",
): any => {
  const branchList: any = [];
  for (const key of keyList) {
    let branch: any = {
      ...findElementInTree(key, tree),
      [childrenKeyName]: [],
    };
    const isExist = branchList.find((b: any) => b[keyName] === branch[keyName]);
    if (isExist) continue;
    branchList.push(branch);
    while (branch[parentKeyName] != null) {
      branch = {
        ...findElementInTree(branch[parentKeyName], tree),
        [childrenKeyName]: [],
      };
      const isExist = branchList.find(
        (b: any) => b[keyName] === branch[keyName],
      );
      if (isExist) continue;
      branchList.push(branch);
    }
  }
  return branchList;
};

export const getLastLevelBranches = (
  tree: any = requiredArgument("Дерево  не передано"),
  childrenKeyName: string = "children",
) => {
  const lastLevelBranches: any = [];

  (function recursiveFind(tree) {
    for (const branch of tree) {
      !(branch[childrenKeyName]?.length > 0)
        ? lastLevelBranches.push(branch)
        : recursiveFind(branch[childrenKeyName]);
    }
  })(tree);

  return lastLevelBranches;
};

export const getFileBase64 = (fileData: any) =>
  fileData?.fileContents
    ? `data:${fileData.contentType};base64,${fileData?.fileContents}`
    : null;

export const toFilterString = (obj: any) =>
  JSON.stringify(
    Object.entries(obj).map(([k, v]) => new Filter(k, v as string)),
  );
export const generateBreadCrumbsFromTree = (
  lastBranch: any = requiredArgument(),
  tree: any = requiredArgument("tree не может быть null"),
  mapPrediacate?: any,
  parentKeyName: any = "parentId",
) => {
  let branch = { ...lastBranch };
  const breadcrumbs: any = [];
  breadcrumbs.push(branch);
  while (branch[parentKeyName]) {
    const prevBranch = findElementInTree(branch[parentKeyName], tree);
    if (!prevBranch) break;
    breadcrumbs.push(prevBranch);
    branch = prevBranch;
  }
  return breadcrumbs.reverse().map((x: any) => mapPrediacate(x));
};

export const getFilePreview = (fileName: string) => {
  switch (fileName.substring(fileName.lastIndexOf(".") + 1)) {
    case "jpg":
    case "JPG":
    case "JPEG":
    case "jpeg":
      return "image-sprite";
    case "pdf":
      return "pdf";
    case "docx":
    case "doc":
      return "docx";
    case "xlsx":
      return "xlsx";
    case "txt":
      return "txt";
    case "pptx":
    case "ppt":
      return "pptx";
    case "mp3":
      return "mp3";
    case "zip":
    case "rar":
      return "zip";
    default:
      return "file";
  }
};

export const generatePassword = () => {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const passwordLength = 8;
  let password = "";
  for (let i = 0; i <= passwordLength; i++) {
    const randomNumber = Math.floor(Math.random() * chars.length);
    password += chars.substring(randomNumber, randomNumber + 1);
  }
  return password;
};

export const translit = (s: string) => {
  const L = {
    А: "A",
    а: "a",
    Б: "B",
    б: "b",
    В: "V",
    в: "v",
    Г: "G",
    г: "g",
    Д: "D",
    д: "d",
    Е: "E",
    е: "e",
    Ё: "Yo",
    ё: "yo",
    Ж: "Zh",
    ж: "zh",
    З: "Z",
    з: "z",
    И: "I",
    и: "i",
    Й: "Y",
    й: "y",
    К: "K",
    к: "k",
    Л: "L",
    л: "l",
    М: "M",
    м: "m",
    Н: "N",
    н: "n",
    О: "O",
    о: "o",
    П: "P",
    п: "p",
    Р: "R",
    р: "r",
    С: "S",
    с: "s",
    Т: "T",
    т: "t",
    У: "U",
    у: "u",
    Ф: "F",
    ф: "f",
    Х: "Kh",
    х: "kh",
    Ц: "Ts",
    ц: "ts",
    Ч: "Ch",
    ч: "ch",
    Ш: "Sh",
    ш: "sh",
    Щ: "Sch",
    щ: "sch",
    Ъ: "",
    ъ: "",
    Ы: "Y",
    ы: "y",
    Ь: "",
    ь: "",
    Э: "E",
    э: "e",
    Ю: "Yu",
    ю: "yu",
    Я: "Ya",
    я: "ya",
    " ": "-",
    "«": "",
    "»": "",
    "%": "",
    "&": "",
    "?": "",
    "#": "",
    $: "",
    "^": "",
    "*": "",
    "№": "",
    ".": "",
    ",": "",
    "–": "",
  };
  let r;
  let k;
  for (k in L) {
    if (k) {
      r += k;
    }
  }

  r = new RegExp(`[${r}]`, "g");

  k = (a) => (a in L ? L[a] : "");

  return s
    .replace(/#|!|"|:|(|)|{|}|%|&|\?|\$|\^/g, "")
    .trim()
    .replace(r, k)
    .replace("--", "-")
    .toLowerCase();
};


export function getClassCaption(classId: number): string {
  switch (classId) {
    case 1: return 'Компонент';
    case 2: return 'Статья';
    case 3: return 'Страница';
    case 4: return 'Новость';
    case 5: return 'Вики-статья';
    case 6: return 'Заболевание';
    case 7: return 'Симптом';
    case 8: return 'Событие';
    case 9: return 'Продукт';
    case 10: return 'Товар';
    case 11: return 'Услуга';
    case 13: return 'Персона';
    case 14: return 'Доктор';
    case 15: return 'Источник контента';
    case 16: return 'Блок контента';
    case 17: return 'Изображение объекта';
    case 18: return 'Расписание события';
    case 19: return 'День события';
    case 20: return 'Время события';
    case 21: return 'Локация события';
    case 22: return 'Сессия события';
    case 23: return 'Элемент сессии';
    case 24: return 'Модератор сессии';
    case 25: return 'Участник сессии';
    case 26: return 'Трансляция события';
    case 27: return 'Профиль пользователя';
    case 28: return 'Профиль компании';
    case 29: return 'Регион';
    case 30: return 'Профиль';
    case 31: return 'Проект';
    case 32: return 'Аудиофайл';
    case 33: return 'Альбом изображений';
    case 34: return 'Блок с изображением';
    case 35: return 'Альбом блока контента';
    case 36: return 'Автор';
    case 37: return 'Сообщение';
    case 38: return 'Проект мессенджера';
    case 39: return 'Проект с аудиофайлом';
    case 40: return 'Файл блока контента';
    case 41: return 'Изображение блока контента';
    case 42: return 'Форма контента';
    case 43: return 'CRM-проект';
    case 44: return 'Звонок';
    case 45: return 'Менеджер клиента';
    case 46: return 'Частный клиент';
    case 47: return 'Корпоративный клиент';
    case 48: return 'Документ';
    case 49: return 'Подписчик';
    case 50: return 'Сценарий рассылки';
    case 51: return 'Фильтр событий';
    case 52: return 'Фильтр менеджеров';
    case 58: return 'Бронирование клиента';
    case 59: return 'Запись к врачу';
    case 60: return 'Геообъект';
    case 61: return 'Компания';
    case 62: return 'Филиал компании';
    case 63: return 'Контакт компонента';
    case 64: return 'Внешняя ссылка';
    case 65: return 'Источник события';
    case 66: return 'Группа источников событий';
    case 67: return 'Звонок клиента';
    case 68: return 'Расчёт клиента';
    case 71: return 'Изображение компонента';
    case 77: return 'SEO-ключ';
    case 78: return 'Автолинк';
    case 79: return 'История компонента';
    case 500: return 'Событие клиента';
    case 501: return 'Клиент';
    case 503: return 'Прикреплённый файл компонента';
    case 504: return 'Связь компонентов';
    case 510: return 'Заказ';
    case 511: return 'Товар заказа';
    case 556: return 'Прайс-лист';
    case 557: return 'Позиция прайс-листа';
    case 558: return 'Клиника';
    case 559: return 'Станция';
    case 561: return 'Папка клиник';
    case 562: return 'Папка компании';
    case 565: return 'Отзыв компонента';
    case 566: return 'Отзыв';
    case 567: return 'Вопрос';
    case 568: return 'Папка отзывов';
    case 569: return 'Папка вопросов';
    case 574: return 'Услуга компании';
    case 575: return 'Геообъект компонента';
    case 579: return 'Лайк компонента';
    case 581: return 'Оценка компонента';
    case 582: return 'Отмена согласия';
    case 586: return 'Резюме';
    case 596: return 'Публикация';
    case 637: return 'Каталог цен';
    case 640: return 'Автор компонента';
    case 641: return 'Папка авторов';
    case 643: return 'Шаблон буклета';
    case 659: return 'Промоакция';
    case 664: return 'Кейс';
    case 667: return 'Валюта';
    case 678: return 'Лог заказа';
    case 680: return 'Лид';
    case 681: return 'Контракт';
    case 691: return 'Промокод';
    case 704: return 'Кейс клиники';
    case 705: return 'AI-модель';
    case 706: return 'Запрос к AI-модели';
    case 707: return 'База ключевых слов';
    default: return `Класс #${classId}`;
  }
}

